export default "__VITE_ASSET__710c5389__"